export default {
  placeholder: '请输入消息...',
  backToBottom: '返回底部',
  clearCurrentDialogue: '清空当前对话',
  clearDialogue: '清空对话',
  clearModalTitle: '你即将要清空会话，清空后将无法找回。是否清空当前会话？',
  defaultHelloMessage: '让我们开始对话吧',
  cancel: '取消',
  confirm: '确认',
  copy: '复制',
  copySuccess: '复制成功',
  delete: '删除',
  edit: '编辑',
  history: '历史范围',
  regenerate: '重新生成'
};